import { useMutation } from 'react-query';

import { removeCardComment } from 'api/endPoints/removeCardComment';

export const useMutationDeleteComment = () => {
    return useMutation<string, QueryError, number>((id) => removeCardComment(id));
};
